import http from '../utils/request'
// let baseUrl = "activity/api/precreate";
let baseUrl = "";
let ourGameApi = {
    /**
     * 获取角色信息
     * @param {Object} data
     */
    getRoleList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetRoleList',
            params: data
        })
    },
    /**
     * 获取角色list
     * @param {Object} data
     */
    getRoleList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetRoleList',
            params: data
        })
    },
    /**
     * 获取绑定信息
     * @param {Object} data
     */
    getBindRoleInfo (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetBindRoleInfo',
            params: data
        })
    },
    /**
     * 绑定角色
     * @param {Object} data
     */
    bindRole (data) {
        return http({
            method: 'get',
            url: baseUrl+'/BindRole',
            params: data
        })
    },
    /**
     * 获取阶段奖品信息
     * @param {Object} data
     */
    getPharseAwardList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetPharseAwardList',
            params: data
        })
    },
    /**
     * 获取抽奖次数
     * @param {Object} data
     */
    getTodayDrawCount (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetTodayDrawCount',
            params: data
        })
    },
    /**
     * 获取奖品信息
     * @param {Object} data
     */
    getAwardList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetAwardList',
            params: data
        })
    },
    /**
     * 所获得的奖品
     * @param {Object} data
     */
    getDrawResult (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetDrawResult',
            params: data
        })
    },
    /**
     * 我的奖品list
     * @param {Object} data
     */
    getWinAwardList (data) {
        return http({
            method: 'get',
            url: baseUrl+'/GetWinAwardList',
            params: data
        })
    },
    /**
     * 开服专题list
     * @param {Object} data
     */
    getActivityList (data) {
        return http({
            method: 'get',
            url: '/config/activityList.json',
            params: data
        })
    },
    /**
     * 登录状态
     * @param {Object} data
     */
    isLogined (data) {
        return http({
            method: 'get',
            url: baseUrl+'/IsLogined',
            params: data
        })
    },
}
export default ourGameApi;


// WEBPACK FOOTER //
// ./src/api/api.js